import { Box } from '@material-ui/core'
import TimerIcon from '@material-ui/icons/Timer'
import { startCase } from 'lodash'
import styled from 'styled-components'

import { Grid } from '../../../components/Base/Base'
import { FlexBox } from '../../../components/Base/FlexBox'
import { Pill } from '../../../components/Pill/Pill'
import { InlineSpinner } from '../../../components/Spinner'
import { Text } from '../../../components/Text/Text'
import { useAvailableTime } from '../../../hooks/query/useAvailableTime'
import { EldAvailableTimeClock, EldAvailableTimeClockRulePolicy } from '../../../models/eld'
import { User } from '../../../models/user'
import { darkGray, lightGray1, lightgreye3, midGray, primaryBlack } from '../../../theme/colors'
import { ProfileHeaderCard } from './ProfileHeader'

interface ProfilePageHOSProps {
  user: User
}

export function ProfilePageHOS({ user }: ProfilePageHOSProps) {
  const { availableTime, isLoading } = useAvailableTime(user.id)

  function renderContent() {
    if (!availableTime) {
      return (
        <Text variant="header3" fontColor={lightGray1} mt={1.8}>
          Not available
        </Text>
      )
    }

    const breakTime = getAvailableTimeForPolicyClock(
      availableTime.clocks,
      EldAvailableTimeClockRulePolicy.DRIVING_BREAK
    )
    const drivingLimitTime = getAvailableTimeForPolicyClock(
      availableTime.clocks,
      EldAvailableTimeClockRulePolicy.DRIVING_LIMIT
    )
    const onDutyLimitTime = getAvailableTimeForPolicyClock(
      availableTime.clocks,
      EldAvailableTimeClockRulePolicy.ON_DUTY_LIMIT
    )
    const cycleLimitTime = getAvailableTimeForPolicyClock(
      availableTime.clocks,
      EldAvailableTimeClockRulePolicy.CYCLE_LIMIT
    )

    return (
      <Grid columns="auto auto auto auto" alignItems="center" gap="10px" mt={2}>
        <div>
          <Text variant="label3" fontColor={lightGray1}>
            Until break
          </Text>
          <Text variant="header3" fontColor={primaryBlack}>
            {breakTime}
          </Text>
        </div>
        <div>
          <Text variant="label3" fontColor={lightGray1}>
            Drive
          </Text>
          <Text variant="header3" fontColor={primaryBlack}>
            {drivingLimitTime}
          </Text>
        </div>
        <div>
          <Text variant="label3" fontColor={lightGray1}>
            Shift
          </Text>
          <Text variant="header3" fontColor={primaryBlack}>
            {onDutyLimitTime}
          </Text>
        </div>
        <div>
          <Text variant="label3" fontColor={lightGray1}>
            Cycle
          </Text>
          <Text variant="header3" fontColor={primaryBlack}>
            {cycleLimitTime}
          </Text>
        </div>
      </Grid>
    )
  }

  return (
    <ProfileHeaderCard>
      <Grid columns="1fr auto" alignItems="center">
        <Text variant="uppercaseLabel2" fontColor={darkGray}>
          <FlexBox alignItems="center" gap="10px">
            <StyledTimerIcon /> <Box mt={0.5}>HOS</Box>
          </FlexBox>
        </Text>
        {availableTime && (
          <Pill background={lightgreye3} color={midGray}>
            {startCase(availableTime.dutyStatus)}
          </Pill>
        )}
      </Grid>

      {isLoading && !availableTime ? <InlineSpinner mt={2} mb={2} /> : renderContent()}
    </ProfileHeaderCard>
  )
}

const getAvailableTimeForPolicyClock = (
  clocks: EldAvailableTimeClock[],
  policy: EldAvailableTimeClockRulePolicy
) => {
  return clocks.find((clock) => clock.rule.policy === policy)?.timeUntilRest || null
}

const StyledTimerIcon = styled(TimerIcon)`
  width: 20px;
`
